import { render, staticRenderFns } from "./fujian.vue?vue&type=template&id=519dc5b4&"
import script from "./fujian.vue?vue&type=script&lang=js&"
export * from "./fujian.vue?vue&type=script&lang=js&"
import style0 from "./fujian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports